/** Display identity never participates in a financial request fingerprint. */
export function paymentMemberText(member: { memberAccountId: number; memberUsername?: string | null }): string {
  return `${member.memberUsername ?? '帳號資料不可用'} · #${member.memberAccountId}`;
}
/** Run before schema defaults: an older API may silently ignore the filter. */
export function requireFilteredPaymentIdentity(path: string, data: unknown): void {
  const url = new URL(path, 'https://local.invalid');
  if (url.pathname !== '/api/admin/payment-orders' && url.pathname !== '/api/admin/payment-orders/') return;
  const username = url.searchParams.get('memberUsername')?.trim();
  if (!username) return;
  const items = (data as { items?: unknown })?.items;
  if (!Array.isArray(items) || items.some(row => !row || typeof row.memberUsername !== 'string' || row.memberUsername !== username))
    throw new Error('API 版本或會員身分不符，已隱藏查詢結果與操作。請更新 API 並重新查詢。');
}
